// src/context/authContext.js
import React, { createContext, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);

  // Load user data from localStorage on app startup
  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    if (storedToken) {
      try {
        const decodedUser = jwtDecode(storedToken);
        setUser(decodedUser);
        setToken(storedToken);
        // Store user_id in localStorage
        localStorage.setItem('user_id', decodedUser.id);
      } catch (error) {
        console.error('Invalid token:', error);
        logout();
      }
    }
  }, []);

  // Function to handle login
  const login = (userData, authToken) => {
    localStorage.setItem('token', authToken);
    setToken(authToken);
    const decodedUser = jwtDecode(authToken);
    setUser(decodedUser);
    // Store user_id in localStorage
    localStorage.setItem('user_id', decodedUser.id);
  };

  // Function to handle logout
  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user_id');
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
